import type { PartialCrmMessages } from "./englishCrmMessages";

/** Auto-generated from docs/i18n/translation-matrix.csv — do not edit by hand */
export const finnishCrmMessages: PartialCrmMessages = {
  crm: {
    action: {
      reset_password: "Nollaa salasana",
    },
    activity: {
      added_company: "%{name} lisäsi asiakkaan",
      added_company_note: "%{name} lisäsi muistiinpanon aiheesta",
      added_contact: "%{name} lisäsi",
      added_deal: "%{name} lisäsi kaupan",
      added_note: "%{name} lisäsi muistiinpanon aiheesta",
      added_note_about_deal: "%{name} lisäsi muistiinpanon kaupasta",
      at_company: "yrityksessä",
      load_more: "Lataa lisää toimintaa",
      to: "–",
      you_added_company: "Lisäsit asiakkaan",
      you_added_company_note: "Lisäsit muistiinpanon aiheesta",
      you_added_contact: "Lisäsit",
      you_added_deal: "Lisäsit kaupan",
      you_added_note: "Lisäsit muistiinpanon aiheesta",
      you_added_note_about_deal: "Lisäsit muistiinpanon kaupasta",
    },
    auth: {
      confirm_password: "Vahvista salasana",
      confirmation_required: "Vahvista tilisi seuraamalla juuri lähettämäämme sähköpostilinkkiä.",
      first_name: "Etunimi",
      last_name: "Sukunimi",
      recovery_email_sent: "Jos olet rekisteröitynyt käyttäjä, saat pian salasanan palautussähköpostin.",
      sign_in_failed: "Kirjautuminen epäonnistui.",
      sign_in_google_workspace: "Kirjaudu Google Workplacella",
      signup: {
        create_account: "Luo tili",
        create_first_user: "Luo ensimmäinen käyttäjätili viimeistelläksesi asennuksen.",
        creating: "Luodaan...",
        initial_user_created: "Ensimmäinen käyttäjä luotu",
      },
      welcome_title: "Tervetuloa Atomic CRM:ään",
    },
    common: {
      activity: "Toiminta",
      added: "lisätty",
      copied: "Kopioitu!",
      copy: "Kopioi",
      details: "Tiedot",
      last_activity_with_date: "viimeisin toiminta %{date}",
      load_more: "Lataa lisää",
      loading: "Ladataan...",
      me: "Minä",
      misc: "Muu",
      past: "Aiemmat",
      read_more: "Lue lisää",
      retry: "Yritä uudelleen",
      show_less: "Näytä vähemmän",
      task_count: "%{smart_count} tehtävä |||| %{smart_count} tehtävää",
    },
    config: {
      company_sectors: {
        "communication-services": "Viestintäpalvelut",
        "consumer-discretionary": "Syklinen kulutus",
        "consumer-staples": "Perustarvikkeet",
        energy: "Energia",
        financials: "Rahoitus",
        "health-care": "Terveydenhuolto",
        industrials: "Teollisuus",
        "information-technology": "Tietotekniikka",
        materials: "Materiaalit",
        "real-estate": "Kiinteistöt",
        utilities: "Yleishyödylliset palvelut",
      },
      deal_categories: {
        copywriting: "Copywriting",
        other: "Muu",
        "print-project": "Painoprojekti",
        "ui-design": "UI-suunnittelu",
        "website-design": "Verkkosivusuunnittelu",
      },
      deal_stages: {
        delayed: "Viivästynyt",
        "in-negociation": "Neuvottelussa",
        lost: "Hävitty",
        opportunity: "Mahdollisuus",
        "proposal-sent": "Tarjous lähetetty",
        won: "Voitettu",
      },
      note_statuses: {
        cold: "Kylmä",
        hot: "Kuuma",
        "in-contract": "Sopimuksessa",
        warm: "Lämmin",
      },
      task_types: {
        call: "Puhelu",
        demo: "Demo",
        email: "Sähköposti",
        "follow-up": "Seuranta",
        lunch: "Lounas",
        meeting: "Tapaaminen",
        none: "Ei mitään",
        ship: "Toimitus",
        "thank-you": "Kiitos",
      },
    },
    dashboard: {
      deals_chart: "Tulevat kauppakirjaukset",
      deals_pipeline: "Kauppaputki",
      latest_activity: "Viimeisin toiminta",
      latest_activity_error: "Viimeisimmän toiminnan lataus epäonnistui",
      latest_notes: "Viimeisimmät muistiinpanoni",
      latest_notes_added_ago: "lisätty %{timeAgo}",
      stepper: {
        install: "Asenna Atomic CRM",
        progress: "%{step}/3 valmis",
        whats_next: "Mitä seuraavaksi?",
      },
      upcoming_tasks: "Tulevat tehtävät",
    },
    email_lists: {
      all_categories: "Kaikki kategoriat",
      brand_description: "Postituslistan kontaktit brändille %{brand}.",
      brand_title: "%{brand} kontaktit",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        gobo_se: "Gobo SE",
        ljusdesign: "Ljusdesign",
      },
      create_contact: "Luo kontakti",
      create_title: "Luo kontakti",
      demo_unavailable: "Sähköpostilistat vaativat Encharge-konfiguraation eivätkä ole käytettävissä demotilassa.",
      description: "Tarkastele ja hallitse Encharge-uutiskirjeitä Gobo-brändeillä.",
      edit_title: "Muokkaa kontaktia",
      empty: "Kontakteja ei löytynyt.",
      exists_prompt: "Tällä sähköpostiosoitteella on jo kontakti. Päivitetäänkö olemassa oleva kontakti?",
      fields: {
        categories: "Viestintäkategoriat",
        company: "Asiakas",
        contact_person: "Gobo-yhteyshenkilö",
        email: "Sähköposti",
        first_name: "Etunimi",
        last_name: "Sukunimi",
        phone: "Puhelin",
        postcode: "Postinumero",
      },
      loading: "Ladataan...",
      loading_more: "Ladataan lisää...",
      match_company: "Vastine asiakkaan perusteella",
      match_email: "Vastine sähköpostin perusteella",
      nav: "Sähköpostilistat",
      saving: "Tallennetaan...",
      search_placeholder: "Hae kontakteja...",
      showing_count: "%{count} kontaktia listalla",
      title: "Sähköpostilistat",
      update_existing: "Päivitä olemassa oleva",
      validation: {
        category_required: "Valitse vähintään yksi viestintäkategoria.",
        required_fields: "Etunimi, sukunimi ja sähköposti ovat pakollisia.",
      },
      widget_empty: "Uutiskirjetilauksia ei löytynyt.",
      widget_no_email: "Lisää sähköpostiosoite nähdäksesi listatilaukset.",
      widget_title: "Sähköpostilistat",
    },
    header: {
      import_data: "Tuo tiedot",
    },
    image_editor: {
      change: "Vaihda",
      drop_hint: "Pudota tiedosto ladattavaksi tai napsauta valitaksesi.",
      editable_content: "Muokattava sisältö",
      title: "Lataa ja muuta kuvan kokoa",
      update_image: "Päivitä kuva",
    },
    import: {
      action: {
        download_error_report: "Lataa virheraportti",
        import: "Tuo",
        import_another: "Tuo toinen tiedosto",
      },
      error: {
        unable: "Tätä tiedostoa ei voitu tuoda.",
      },
      idle: {
        description_1: "Voit tuoda käyttäjiä, asiakkaita, kontakteja, muistiinpanoja ja tehtäviä.",
        description_2: "Tiedon on oltava JSON-tiedostossa, joka vastaa seuraavaa mallia:",
      },
      status: {
        all_success: "Kaikki tietueet tuotiin onnistuneesti.",
        complete: "Tuonti valmis.",
        failed: "Epäonnistui",
        imported: "Tuotu",
        in_progress: "Tuonti käynnissä — älä poistu tältä sivulta.",
        some_failed: "Joitakin tietueita ei tuotu.",
        table_caption: "Tuonnin tila",
      },
      title: "Tuo tiedot",
    },
    language: "Kieli",
    mobile_nav: {
      close_menu: "Sulje",
      mega_menu_title: "Valikko",
      my_tasks: "Omat tehtävät",
      open_menu: "Avaa valikko",
      section_account: "Tili",
      section_main: "Pää",
    },
    navigation: {
      label: "CRM-navigointi",
    },
    profile: {
      inbound: {
        description: "Voit alkaa lähettää sähköpostia palvelimesi saapuvaan sähköpostiosoitteeseen, esimerkiksi lisäämällä sen kenttään %{field}. Atomic CRM käsittelee viestit ja lisää muistiinpanoja vastaaviin kontakteihin.",
        title: "Saapuva sähköposti",
      },
      mcp: {
        description: "Käytä tätä URL-osoitetta yhdistääksesi AI-avustajasi CRM-dataan Model Context Protocol (MCP) -protokollan kautta.",
        title: "MCP Server",
      },
      password: {
        change: "Vaihda salasana",
      },
      password_reset_sent: "Salasanan nollausviesti on lähetetty sähköpostiisi",
      record_not_found: "Tietuetta ei löytynyt",
      title: "Profiili",
      update_error: "Tapahtui virhe. Yritä uudelleen",
      updated: "Profiilisi on päivitetty",
    },
    recent_website_activity: {
      demo_unavailable: "Viimeisin verkkotoiminta vaatii Leadboxer-konfiguraation eikä ole käytettävissä demotilassa.",
      empty: "Viimeisintä verkkotoimintaa ei löytynyt",
      loading: "Ladataan...",
      match_reason: {
        domain: "Vastine verkkotunnuksen perusteella",
        domain_alias: "Vastine verkkotunnusaliaksen perusteella",
        email_domain: "Vastine sähköpostiverkkotunnuksen perusteella",
        linkedin: "Vastine LinkedInin perusteella",
        name: "Vastine nimen perusteella",
      },
      summary: "%{count} käyntiä · %{visits} istuntoa · %{events} sivunäyttöä (uusin)",
      title: "Viimeisin verkkotoiminta",
    },
    settings: {
      app_title: "Sovelluksen otsikko",
      companies: {
        segments: "Segmentit",
      },
      dark_mode_logo: "Tumma tila -logo",
      deals: {
        categories: "Kategoriat",
        currency: "Valuutta",
        pipeline_help: "Valitse, mitkä kauppavaiheet lasketaan putken kaupoiksi.",
        pipeline_statuses: "Putken tilat",
        stages: "Vaiheet",
      },
      light_mode_logo: "Vaalea tila -logo",
      notes: {
        statuses: "Tilat",
      },
      preferences: "Asetukset",
      reset_defaults: "Palauta oletukset",
      save_error: "Asetusten tallennus epäonnistui",
      saved: "Asetukset tallennettu",
      saving: "Tallennetaan...",
      sections: {
        bc_sync: "BC Sync",
        branding: "Brändäys",
        notifications: "Ilmoitukset",
      },
      tasks: {
        types: "Tyypit",
      },
      title: "Asetukset",
      validation: {
        duplicate: "Kaksoiskappale %{display_name}: %{items}",
        entities: {
          categories: "kategoriat",
          stages: "vaiheet",
        },
        in_use: "Ei voi poistaa %{display_name}, joita kaupat käyttävät edelleen: %{items}",
        validating: "Validoidaan…",
      },
    },
    theme: {
      dark: "Tumma",
      label: "Teema",
      light: "Vaalea",
      system: "Järjestelmä",
    },
    validation: {
      invalid_linkedin_url: "URL:n on oltava linkedin.com-osoite",
      invalid_url: "Oltava kelvollinen URL",
    },
    visitor_insights: {
      brand_description: "Verkkosivukäyntidata brändille %{brand}.",
      brand_title: "%{brand} kävijäanalytiikka",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        gobo_se: "Gobo SE",
        ljusdesign: "Ljusdesign",
      },
      columns: {
        employees: "Työntekijät",
        events: "Tapahtumat",
        industry: "Toimiala",
        last_activity: "Viimeisin toiminta",
        last_channel: "Viimeisin kanava",
        summary: "Yhteenveto",
        visits: "Käynnit",
      },
      demo_unavailable: "Kävijätiedot vaativat Leadboxer-konfiguraation eivätkä ole käytettävissä demotilassa.",
      description: "Näytä verkkosivuillanne vierailevat tunnistetut organisaatiot.",
      empty: "Kävijöitä ei löytynyt tälle jaksolle.",
      fields: {
        employees: "Työntekijät",
        industry: "Toimiala",
        location: "Sijainti",
        phone: "Puhelin",
        score: "Pisteet",
        tags: "Tunnisteet",
        website: "Verkkosivusto",
      },
      loading: "Ladataan...",
      loading_sessions: "Ladataan istuntoja...",
      nav: "Kävijäanalytiikka",
      no_sessions: "Tälle liidille ei löytynyt istuntoja.",
      period: {
        last_24h: "Viimeiset 24 tuntia",
        last_30d: "Viimeiset 30 päivää",
        last_3d: "Viimeiset 3 päivää",
        last_7d: "Viimeiset 7 päivää",
      },
      session_events: "Istuntotapahtumat",
      title: "Kävijäanalytiikka",
      view_customer: "Näytä asiakas",
    },
    voice_agent: {
      language: "Äänikieli",
    },
    bc_environment: {
      label: "Ensisijainen BC-ympäristö",
    },
  },
  resources: {
    campaigns: {
      assignee: {
        required: "Valitse vastuuhenkilö",
      },
      complete_note: {
        placeholder: "Kirjoita muistiinpano tästä käynnistä tai puhelusta…",
        save: "Tallenna muistiinpano",
        saved_to_company: "Muistiinpano tallennetaan asiakkaalle: %{name}",
        saved_to_contact: "Muistiinpano tallennetaan kontaktille: %{name}",
        skip: "Merkitse valmiiksi ilman muistiinpanoa",
        success: "Tehtävä valmis",
        title: "Lisää muistiinpano tehtävään",
      },
      fields: {
        assignee: "Vastuuhenkilö",
        description: "Kuvaus",
        instructions: "Ohjeet",
        kind: "Tehtävätyyppi",
        name: "Nimi",
        product_name: "Tuote",
        status: "Tila",
        targets: "Kohteet",
        title: "Otsikko",
      },
      generate: {
        action: "Luo tehtävät",
        confirm: "Luo",
        created: "Luotu",
        deleted: "Poistettu",
        fallback: "Varamyyjä",
        fallback_help: "Valitse varamyyjä kohteille, joilla ei ole nimettyä myyjää.",
        missing: "Ohitettu (ei myyjää)",
        reconcile: "Täsmäytä tehtävät",
        skipped: "Ohitettu",
        success: "Tehtävät luotu",
      },
      kinds: {
        follow_up: "Seuranta",
        meeting: "Tapaaminen",
        newsletter: "Lähetä uutiskirje",
        personal_task: "Henkilökohtainen tehtävä",
        phone_call: "Puhelu",
        send_info: "Lähetä tuotetiedot",
        send_samples: "Lähetä näytteitä",
        visit_demo: "Käynti ja demo",
      },
      metadata: {
        materials: "Lähetettävät materiaalit",
        meeting_format: "Tapaamisen muoto (in_person tai online)",
        newsletter_subject: "Uutiskirjeen aihe",
        notes: "Muistiinpanot",
        product_to_demo: "Demottava tuote",
        sample_description: "Näytteen kuvaus",
        talk_points: "Keskustelunaiheet",
      },
      name: "Kampanja |||| Kampanjat",
      open_tasks: {
        all_completed: "Kaikki tehtävät valmiit.",
        campaign_task: "Kampanjatehtävä",
        company_fallback: "Asiakas #%{id}",
        contact_fallback: "Kontakti #%{id}",
        show_completed: "Näytä valmiit",
        title: "Tehtävät",
      },
      progress: {
        label: "Edistyminen",
        overdue_count: "%{count} myöhässä",
      },
      status: {
        active: "Aktiivinen",
        completed: "Valmis",
        draft: "Luonnos",
        open: "Avoin",
        overdue: "Myöhässä",
        snoozed: "Torkulla",
      },
      tabs: {
        definitions: "Tehtävämääritykset",
        my_tasks: "Omat tehtävät",
        overview: "Yleiskatsaus",
      },
      targets: {
        add: "Lisää kohde",
        required: "Lisää vähintään yksi kohde",
      },
      task_definitions: {
        add: "Lisää tehtävämääritys",
        edit: "Muokkaa tehtävämääritystä",
        empty: "Ei tehtävämäärityksiä vielä.",
        generated: "Luotu",
        targets: "kohteet",
      },
    },
    companies: {
      action: {
        create: "Luo asiakas",
        edit: "Muokkaa asiakasta",
        new: "Uusi asiakas",
        show: "Näytä asiakas",
      },
      added_on: "Lisätty %{date}",
      autocomplete: {
        create_error: "Asiakkaan luonnissa tapahtui virhe",
        create_item: "Luo %{item}",
        create_label: "Aloita kirjoittaminen luodaksesi uuden asiakkaan",
      },
      empty: {
        bc_sync_description: "Asiakkaat synkronoidaan Business Centralista. Tarkista Asetukset → BC Sync tai odota yöllistä synkronointia.",
        description: "Asiakasluettelosi näyttää olevan tyhjä.",
        title: "Asiakkaita ei löytynyt",
      },
      field_categories: {
        additional_info: "Lisätiedot",
        address: "Osoite",
        contact: "Kontakti",
        context: "Konteksti",
      },
      fields: {
        address: "Osoite",
        city: "Kaupunki",
        context_links: "Kontekstilinkit",
        country: "Maa",
        created_at: "Luotu",
        description: "Kuvaus",
        linkedin_url: "LinkedIn-URL",
        name: "Asiakkaan nimi",
        nb_contacts: "Yhteyshenkilöiden määrä",
        phone_number: "Puhelinnumero",
        revenue: "Liikevaihto",
        sales_id: "Asiakasvastaava",
        sector: "Segmentti",
        segments: "Segmentit",
        size: "Koko",
        state_abbr: "Maakunta",
        tax_identifier: "Y-tunnus",
        website: "Verkkosivusto",
        zipcode: "Postinumero",
      },
      filters: {
        only_mine: "Vain minun hallinnoimani asiakkaat",
      },
      followed_by: "Myyjä: %{name}",
      followed_by_you: "Myyjä: sinä",
      forcedCaseName: "Asiakas",
      name: "Asiakas |||| Asiakkaat",
      nb_contacts: "%{smart_count} kontakti |||| %{smart_count} kontaktia",
      nb_deals: "%{smart_count} kauppa |||| %{smart_count} kauppaa",
      no_contacts: "Ei yhteyshenkilöä",
      sizes: {
        fifty_to_two_hundred_forty_nine_employees: "50–249 työntekijää",
        one_employee: "1 työntekijä",
        ten_to_forty_nine_employees: "10–49 työntekijää",
        two_hundred_fifty_or_more_employees: "250 tai enemmän työntekijää",
        two_to_nine_employees: "2–9 työntekijää",
      },
    },
    contacts: {
      action: {
        add: "Lisää kontakti",
        add_first: "Lisää ensimmäinen kontaktisi",
        browse_synced: "Selaa synkronoituja kontakteja",
        create: "Luo kontakti",
        edit: "Muokkaa kontaktia",
        export_vcard: "Vie vCard-muodossa",
        new: "Uusi kontakti",
        show: "Näytä kontakti",
      },
      background: {
        added_on: "Lisätty %{date}",
        followed_by: "Myyjä: %{name}",
        followed_by_you: "Myyjä: sinä",
        last_activity_on: "Viimeisin toiminta %{date}",
        status_none: "Ei mitään",
      },
      bulk_tag: {
        action: "Merkitse",
        back: "Takaisin tunnisteisiin",
        create_description: "Luo uusi tunniste ja lisää se valittuihin kontakteihin.",
        description: "Valitse olemassa oleva tunniste tai luo uusi valituille kontakteille.",
        empty: "Ei tunnisteita vielä. Luo tunniste valittujen kontaktien merkitsemiseksi.",
        error: "Tunnisteen lisääminen kontakteihin epäonnistui",
        noop: "Valituilla kontakteilla on jo tämä tunniste",
        success: "Tunniste lisätty %{smart_count} kontaktiin |||| Tunniste lisätty %{smart_count} kontaktiin",
        title: "Lisää tunniste kontakteihin",
      },
      empty: {
        bc_sync_description: "Kontaktit synkronoidaan Business Centralista. Tarkista Asetukset → BC Sync tai odota yöllistä synkronointia.",
        description: "Yhteystietoluettelosi näyttää olevan tyhjä.",
        title: "Kontakteja ei löytynyt",
      },
      field_categories: {
        background_info: "Tausta",
        identity: "Identiteetti",
        misc: "Muu",
        personal_info: "Henkilötiedot",
        position: "Asema",
      },
      fields: {
        background: "Tausta (esittely, miten tapasitte jne.)",
        company_id: "Asiakas",
        email: "Sähköposti",
        email_jsonb: "Sähköpostiosoitteet",
        first_name: "Etunimi",
        has_newsletter: "Tilaa uutiskirjeen",
        last_name: "Sukunimi",
        last_seen: "Viimeksi nähty",
        linkedin_url: "LinkedIn-URL",
        phone_jsonb: "Puhelinnumerot",
        phone_number: "Puhelinnumero",
        sales_id: "Asiakasvastaava",
        title: "Otsikko",
      },
      filters: {
        before_last_month: "Ennen viime kuuta",
        before_this_month: "Ennen tätä kuuta",
        before_this_week: "Ennen tätä viikkoa",
        managed_by_me: "Minun hallinnoimani",
        search: "Hae nimeä, asiakasta...",
        tags: "Tunnisteet",
        tasks: "Tehtävät",
        this_week: "Tämä viikko",
        today: "Tänään",
      },
      forcedCaseName: "Kontakti",
      hot: {
        empty_change_status: "Vaihda kontaktin tilaa lisäämällä kontaktille muistiinpano ja napsauttamalla \"näytä asetukset\".",
        empty_hint: "Kontaktit, joiden tila on \"kuuma\", näkyvät täällä.",
        title: "Kuumat kontaktit",
      },
      import: {
        button: "Tuo CSV",
        complete: "Kontaktien tuonti valmis. Tuotiin %{importCount} kontaktia, %{errorCount} virhettä",
        contacts_label: "kontakti |||| kontaktia",
        csv_file: "CSV-tiedosto",
        error: "Tiedoston tuonti epäonnistui. Varmista, että tiedosto on kelvollinen CSV.",
        imported: "Tuotu",
        progress: "Tuotu %{importCount} / %{rowCount} kontaktia, %{errorCount} virhettä.",
        remaining_time: "Arvioitu jäljellä oleva aika:",
        running: "Tuonti on käynnissä — älä sulje tätä välilehteä.",
        sample_download: "Lataa CSV-malli",
        sample_hint: "Tässä on CSV-malli, jota voit käyttää pohjana",
        stop: "Pysäytä tuonti",
        title: "Tuo kontaktit",
      },
      inputs: {
        genders: {
          female: "Hän",
          male: "Hän",
          nonbinary: "He/He",
        },
        personal_info_types: {
          home: "Koti",
          other: "Muu",
          work: "Työ",
        },
      },
      list: {
        error_loading: "Kontaktien lataus epäonnistui",
      },
      merge: {
        action: "Yhdistä toiseen kontaktiin",
        confirm: "Yhdistä kontaktit",
        current_contact: "Nykyinen kontakti (poistetaan)",
        description: "Yhdistä tämä kontakti toiseen.",
        error: "Kontaktien yhdistäminen epäonnistui",
        merging: "Yhdistetään...",
        no_additional_data: "Ei yhdistettävää lisätietoa",
        select_target: "Valitse kontakti, johon yhdistetään",
        success: "Kontaktit yhdistetty",
        target_contact: "Kohdekontakti (säilytetään)",
        title: "Yhdistä kontakti",
        warning_description: "Kaikki tiedot siirretään toiseen kontaktiin. Toimintoa ei voi perua.",
        warning_title: "Varoitus: Tuhoava toimenpide",
        what_will_be_merged: "Yhdistettävät tiedot:",
      },
      name: "Kontakti |||| Kontaktit",
      position_at: "%{title},",
      position_at_company: "%{title}, %{company}",
      part_of_company: "Osa: %{name}",
      open_company: "Avaa asiakas",
    },
    deals: {
      action: {
        back_to_deal: "Takaisin kauppaan",
        create: "Luo kauppa",
        new: "Uusi kauppa",
      },
      archived: {
        action: "Arkistoi",
        error: "Virhe: kauppaa ei arkistoitu",
        list_title: "Arkistoidut kaupat",
        success: "Kauppa arkistoitu",
        title: "Arkistoitu kauppa",
        view: "Näytä arkistoidut kaupat",
      },
      empty: {
        before_create: "ennen kaupan luomista.",
        description: "Kauppaluettelosi näyttää olevan tyhjä.",
        title: "Kauppoja ei löytynyt",
      },
      field_categories: {
        misc: "Muu",
      },
      fields: {
        amount: "Budjetti",
        category: "Kategoria",
        company_id: "Asiakas",
        contact_ids: "Kontaktit",
        description: "Kuvaus",
        expected_closing_date: "Arvioitu päättymispäivä",
        name: "Nimi",
        stage: "Vaihe",
      },
      inputs: {
        linked_to: "Linkitetty",
      },
      invalid_date: "Virheellinen päivämäärä",
      name: "Kauppa |||| Kauppaa",
      unarchived: {
        action: "Palauta taululle",
        error: "Virhe: kauppaa ei palautettu",
        success: "Kauppa palautettu",
      },
      updated: "Kauppa päivitetty",
    },
    notes: {
      action: {
        add: "Lisää muistiinpano",
        add_first: "Lisää ensimmäinen muistiinpanosi",
        add_this: "Lisää tämä muistiinpano",
        delete: "Poista muistiinpano",
        edit: "Muokkaa muistiinpanoa",
        update: "Päivitä muistiinpano",
      },
      actions: {
        attach_document: "Liitä asiakirja",
      },
      added: "Muistiinpano lisätty",
      author_added: "%{name} lisäsi muistiinpanon",
      deleted: "Muistiinpano poistettu",
      empty: "Ei muistiinpanoja vielä",
      fields: {
        attachments: "Liitteet",
        contact_id: "Kontakti",
        date: "Päivämäärä",
        deal_id: "Kauppa",
        status: "Tila",
      },
      forcedCaseName: "Muistiinpano",
      inputs: {
        add_note: "Lisää muistiinpano",
        options_hint: "(liitä tiedostoja tai muuta tietoja)",
        show_options: "Näytä asetukset",
      },
      list: {
        error_loading: "Muistiinpanojen lataus epäonnistui",
      },
      me: "Minä",
      name: "Muistiinpano |||| Muistiinpanot",
      note_for_contact: "Muistiinpano: %{name}",
      sheet: {
        create: "Luo muistiinpano",
        create_for: "Luo muistiinpano: %{name}",
        edit: "Muokkaa muistiinpanoa",
        edit_for: "Muokkaa muistiinpanoa: %{name}",
      },
      stepper: {
        hint: "Siirry kontaktisivulle ja lisää muistiinpano",
      },
      validation: {
        note_or_attachment_required: "Muistiinpano tai liite vaaditaan",
      },
      you_added: "Lisäsit muistiinpanon",
    },
    sales: {
      action: {
        new: "Uusi käyttäjä",
      },
      create: {
        error: "Käyttäjän luonnissa tapahtui virhe.",
        success: "Käyttäjä luotu. Hän saa pian sähköpostin salasanan asettamista varten.",
        title: "Luo uusi käyttäjä",
      },
      edit: {
        error: "Tapahtui virhe. Yritä uudelleen.",
        record_not_found: "Tietuetta ei löytynyt",
        success: "Käyttäjä päivitetty",
        title: "Muokkaa: %{name}",
      },
      fields: {
        administrator: "Admin",
        disabled: "Poistettu käytöstä",
        email: "Sähköposti",
        first_name: "Etunimi",
        last_name: "Sukunimi",
      },
      name: "Käyttäjä |||| Käyttäjät",
    },
    tags: {
      action: {
        add: "Lisää tunniste",
        create: "Luo uusi tunniste",
      },
      dialog: {
        color: "Väri",
        create_title: "Luo uusi tunniste",
        edit_title: "Muokkaa tunnistetta",
        name_label: "Tunnisteen nimi",
        name_placeholder: "Syötä tunnisteen nimi",
      },
      name: "Tunniste |||| Tunnisteet",
    },
    tasks: {
      action: {
        add: "Lisää tehtävä",
        create: "Luo tehtävä",
        edit: "Muokkaa tehtävää",
      },
      actions: {
        postpone_next_week: "Siirrä ensi viikkoon",
        postpone_tomorrow: "Siirrä huomiseen",
        title: "tehtävätoiminnot",
      },
      added: "Tehtävä lisätty",
      deleted: "Tehtävä poistettu",
      dialog: {
        create: "Luo tehtävä",
        create_for: "Luo tehtävä: %{name}",
      },
      empty: "Ei tehtäviä vielä",
      empty_list_hint: "Kontakteihisi lisätyt tehtävät näkyvät täällä.",
      fields: {
        contact_id: "Kontakti",
        due_date: "Eräpäivä",
        due_short: "erääntyy",
        text: "Kuvaus",
        type: "Tyyppi",
      },
      filters: {
        campaign_tasks: "Vain kampanjatehtävät",
        later: "Myöhemmin",
        overdue: "Myöhässä",
        this_week: "Tämä viikko",
        today: "Tänään",
        tomorrow: "Huomenna",
        with_pending: "Odottavilla tehtävillä",
      },
      forcedCaseName: "Tehtävä",
      name: "Tehtävä |||| Tehtävät",
      recurrence: {
        badge: "Toistuva",
        custom: "Mukautettu",
        days: "Päivät",
        enabled: "Toistuva tehtävä",
        end_date: "Päättymispäivä",
        every_count: "Väli",
        every_count_help: "Käytä 1 joka välillä tai suurempaa lukua joka N. välin kohdalla.",
        every_day: "Joka päivä",
        every_month: "Joka kuukausi",
        every_unit: "Yksikkö",
        every_week: "Joka viikko",
        every_year: "Joka vuosi",
        has_end_date: "Aseta päättymispäivä",
        months: "Kuukaudet",
        weeks: "Viikot",
        years: "Vuodet",
      },
      regarding_company: "(Aihe: %{name})",
      regarding_contact: "(Aihe: %{name})",
      sheet: {
        edit: "Muokkaa tehtävää",
        edit_for: "Muokkaa tehtävää: %{name}",
      },
      updated: "Tehtävä päivitetty",
    },
  },
};

